import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * Created by AAravindan on 5/4/16.
 */
import { Indicator, IndicatorInput } from "../indicator/indicator";
import { CandleList } from "../StockData";
export var HeikinAshiInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(HeikinAshiInput, _IndicatorInput);

  function HeikinAshiInput() {
    _classCallCheck(this, HeikinAshiInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(HeikinAshiInput).apply(this, arguments));
  }

  return HeikinAshiInput;
}(IndicatorInput);
export var HeikinAshi =
/*#__PURE__*/
function (_Indicator) {
  _inherits(HeikinAshi, _Indicator);

  function HeikinAshi(input) {
    var _this;

    _classCallCheck(this, HeikinAshi);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HeikinAshi).call(this, input));
    var format = _this.format;
    _this.result = new CandleList();
    var lastOpen = null;
    var lastHigh = 0;
    var lastLow = Infinity;
    var lastClose = 0;
    var lastVolume = 0;
    var lastTimestamp = 0;
    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var candleData, calculated, newClose, newOpen, newHigh, newLow;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return;

            case 2:
              candleData = _context.sent;
              calculated = null;

            case 4:
              if (!true) {
                _context.next = 11;
                break;
              }

              if (lastOpen === null) {
                lastOpen = (candleData.close + candleData.open) / 2;
                lastHigh = candleData.high;
                lastLow = candleData.low;
                lastClose = (candleData.close + candleData.open + candleData.high + candleData.low) / 4;
                lastVolume = candleData.volume || 0;
                lastTimestamp = candleData.timestamp || 0;
                calculated = {
                  open: lastOpen,
                  high: lastHigh,
                  low: lastLow,
                  close: lastClose,
                  volume: candleData.volume || 0,
                  timestamp: candleData.timestamp || 0
                };
              } else {
                newClose = (candleData.close + candleData.open + candleData.high + candleData.low) / 4;
                newOpen = (lastOpen + lastClose) / 2;
                newHigh = Math.max(newOpen, newClose, candleData.high);
                newLow = Math.min(candleData.low, newOpen, newClose);
                calculated = {
                  close: newClose,
                  open: newOpen,
                  high: newHigh,
                  low: newLow,
                  volume: candleData.volume || 0,
                  timestamp: candleData.timestamp || 0
                };
                lastClose = newClose;
                lastOpen = newOpen;
                lastHigh = newHigh;
                lastLow = newLow;
              }

              _context.next = 8;
              return calculated;

            case 8:
              candleData = _context.sent;
              _context.next = 4;
              break;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this.generator.next();

    input.low.forEach(function (tick, index) {
      var result = _this.generator.next({
        open: input.open[index],
        high: input.high[index],
        low: input.low[index],
        close: input.close[index],
        volume: input.volume ? input.volume[index] : input.volume,
        timestamp: input.timestamp ? input.timestamp[index] : input.timestamp
      });

      if (result.value) {
        _this.result.open.push(result.value.open);

        _this.result.high.push(result.value.high);

        _this.result.low.push(result.value.low);

        _this.result.close.push(result.value.close);

        _this.result.volume.push(result.value.volume);

        _this.result.timestamp.push(result.value.timestamp);
      }
    });
    return _this;
  }

  _createClass(HeikinAshi, [{
    key: "nextValue",
    value: function nextValue(price) {
      var result = this.generator.next(price).value;
      return result;
    }
  }]);

  return HeikinAshi;
}(Indicator);
HeikinAshi.calculate = heikinashi;
export function heikinashi(input) {
  Indicator.reverseInputs(input);
  var result = new HeikinAshi(input).result;

  if (input.reversedInput) {
    result.open.reverse();
    result.high.reverse();
    result.low.reverse();
    result.close.reverse();
    result.volume.reverse();
    result.timestamp.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}